import React from "react";
import { Button, Tooltip, withStyles } from "@material-ui/core";
import { InfoOutlined } from "@material-ui/icons";
import { BannerAlert } from "features/shared/components";
import { useTranslations, Trans } from "adapters/i18n";

const BannerNameExists = ({
  classes,
  sameNameFormula,
  submmitDisabled,
  handleClose,
  handleSubmmit,
}) => {
  const { t } = useTranslations();
  const tooltipMessage = submmitDisabled
    ? t("common:validation.fill-all-required-fields")
    : "";

  return (
    <BannerAlert
      className={classes.container}
      customIcon={<InfoOutlined color="error" />}
      type="error"
    >
      <div className={classes.content}>
        <div>
          <Trans
            i18nKey="formulation:register.name-exists-msg"
            values={{ sameNameFormula }}
            components={{ b: <b /> }}
          />
        </div>
        <div
          className={classes.actionButtons}
          data-testid="banner-name-butons-container"
        >
          <Button variant="text" onClick={handleClose}>
            {t("common:actions.cancel")}
          </Button>
          <Tooltip
            title={tooltipMessage}
            placement="bottom"
            classes={{ tooltip: classes.tooltip }}
          >
            <Button
              variant="text"
              onClick={handleSubmmit}
              disabled={submmitDisabled}
              classes={{
                root: classes.subimmitButton,
                disabled: classes.submmitDisabled,
              }}
            >
              {t("formulation:register.deactivate-copy")}
            </Button>
          </Tooltip>
        </div>
      </div>
    </BannerAlert>
  );
};

const styles = () => ({
  container: {
    alignSelf: "flex-start",
    marginBottom: "32px",
    maxWidth: "800px",
  },
  content: {
    display: "flex",
    flexDirection: "column",
    gap: "8px",
  },
  actionButtons: {
    display: "flex",
    flexDirection: "row",
    alignItems: "center",
    justifyContent: "end",
    gap: "8px",
    "& button": {
      fontSize: 12,
    },
  },
  subimmitButton: {
    fontSize: 12,
    color: "#d32f2f",
  },
  submmitDisabled: {
    color: "rgba(0, 0, 0, 0.26)",
  },
  tooltip: {
    padding: "16px",
    borderRadius: "4px",
    fontFamily: "Roboto",
    fontSize: "14px",
  },
});

export default withStyles(styles)(BannerNameExists);
